module.exports = __webpack_public_path__ + "static/media/finanziamenti-logo.5bac1e53.svg";